import type { Recommendation } from "~/src/generated-sources/core";

export default (recommendations: Recommendation[]) => {
  return recommendations.filter((r) => r.redeemedAt);
};
